import "core-js/modules/es.json.stringify.js";
import { ArrowDown } from "@element-plus/icons-vue";
import { Back } from "@element-plus/icons-vue";
import { GetUsersByIdApi } from "@/api/userManagementApi.js";
import { onMounted, reactive, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { searchList, getPara } from "@/assets/js/tool.js";
export default {
  name: "Head-com",
  components: {
    ArrowDown
  },
  setup() {
    let route = useRoute();
    let router = useRouter();
    let linkMenuShow = ref(false);
    let userInfo = reactive({});
    let showHeader = ref(true);
    if (getPara("appKey")) {
      showHeader.value = false;
    }
    //清除上一个用户信息
    window.localStorage.removeItem("gz-userInfo");
    let heightCss = ref("60");
    onMounted(() => {
      if (window.location.hash.indexOf("trial") != -1) {
        userInfo.schoolName = "";
        userInfo.name = "快速体验";
        window.localStorage.setItem("gz-userInfo", JSON.stringify(userInfo));
      } else {
        GetUsersByIdApi(window.localStorage.getItem("fltrp-home-userId")).then(r => {
          if (r.status == 200) {
            for (let key in r.data) {
              userInfo[key] = r.data[key];
            }
            window.localStorage.setItem("gz-userInfo", JSON.stringify(userInfo));
            if (!userInfo.extendInfo) {
              router.replace({
                path: "/userextend",
                query: searchList()
              });
            }
          }
        });
      }
    });
    function goHomePage() {
      window.location.href = "/";
    }
    //登出
    function logout() {
      window.close();
    }
    function linkMenu() {
      setTimeout(() => {
        linkMenuShow.value = !linkMenuShow.value;
      }, 0);
    }
    //样式设置
    watch(() => route.path, () => {
      if (route && (route.meta.type == "exam" || route.meta.type == "user")) {
        heightCss.value = 0;
      } else {
        heightCss.value = 60;
      }
    }, {
      immediate: true
    });
    document.addEventListener("click", e => {
      if (!e.target.className || typeof e.target.className != "string" || e.target.className.indexOf("head-user") == -1) {
        linkMenuShow.value = false;
      }
    });
    return {
      router,
      route,
      userInfo,
      Back,
      heightCss,
      logout,
      linkMenu,
      linkMenuShow,
      showHeader,
      goHomePage
    };
  }
};